export enum ImportElemStatus {
	VALIDATED = 'Validated',
	USER_VALIDATED = 'userValidated',
}
